/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectWorkPackageCategoryGroupsDto } from '../../models/project-work-package-category-groups-dto';

export interface GetProjectWorkPackageCategoryGroups$Params {
  id: string;
}

export function getProjectWorkPackageCategoryGroups(http: HttpClient, rootUrl: string, params: GetProjectWorkPackageCategoryGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectWorkPackageCategoryGroupsDto>> {
  const rb = new RequestBuilder(rootUrl, getProjectWorkPackageCategoryGroups.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectWorkPackageCategoryGroupsDto>;
    })
  );
}

getProjectWorkPackageCategoryGroups.PATH = '/v0/projects/{id}/categoryGroups';
